/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Video_Encoding_ExtendedInputs */

const en_audio_description_export_status_video_encoding_extended = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encoding extended AD video with frame holds...`)
};

const fr_audio_description_export_status_video_encoding_extended = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encodage de la vidéo AD étendue avec images figées...`)
};

const de_audio_description_export_status_video_encoding_extended = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codierung von erweitertem AD-Video mit Frame-Holds...`)
};

const it_audio_description_export_status_video_encoding_extended = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifica di video AD esteso con frame hold...`)
};

const ru_audio_description_export_status_video_encoding_extended = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кодирование расширенного AD-видео с удержанием кадров...`)
};

const es_audio_description_export_status_video_encoding_extended = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificación de vídeo AD extendido con retención de cuadros...`)
};

const zh_cn2_audio_description_export_status_video_encoding_extended = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用帧保持功能对扩展 AD 视频进行编码……`)
};

const ja_audio_description_export_status_video_encoding_extended = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フレーム ホールドを使用して拡張 AD ビデオをエンコードしています...`)
};

const hi_audio_description_export_status_video_encoding_extended = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ्रेम होल्ड के साथ विस्तारित AD वीडियो को एनकोड करना...`)
};

const pt_pt2_audio_description_export_status_video_encoding_extended = /** @type {(inputs: Audio_Description_Export_Status_Video_Encoding_ExtendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificação de vídeo AD estendido com retenção de quadros...`)
};

/**
* | output |
* | --- |
* | "Encoding extended AD video with frame holds..." |
*
* @param {Audio_Description_Export_Status_Video_Encoding_ExtendedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_video_encoding_extended = /** @type {((inputs?: Audio_Description_Export_Status_Video_Encoding_ExtendedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Video_Encoding_ExtendedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_video_encoding_extended(inputs)
	if (locale === "de") return de_audio_description_export_status_video_encoding_extended(inputs)
	if (locale === "it") return it_audio_description_export_status_video_encoding_extended(inputs)
	if (locale === "ru") return ru_audio_description_export_status_video_encoding_extended(inputs)
	if (locale === "es") return es_audio_description_export_status_video_encoding_extended(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_video_encoding_extended(inputs)
	if (locale === "ja") return ja_audio_description_export_status_video_encoding_extended(inputs)
	if (locale === "hi") return hi_audio_description_export_status_video_encoding_extended(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_video_encoding_extended(inputs)
	return en_audio_description_export_status_video_encoding_extended(inputs)
});